<mat-dialog-content>
    <div class="p-2">
        <div class="col-12">
            <h2>user search</h2>
            <app-primary-user-search [isDialog]='true' [personType]="data" (userSelected)="userSelected($event)" (searchCancelled)="searchCancelled()"></app-primary-user-search>
        </div>
    </div>
</mat-dialog-content>

